import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
// import logo from "../../assets/logo-white.svg";
import logo from "../../assets/logo_white_new.svg";
import { designTokens } from "../../theme/designTokens";
import { footerContent } from "../../theme/homeContent";

const { colors } = designTokens;

const Footer = () => (
  <Box id="contact" sx={{ backgroundColor: colors.footerBg, color: colors.white }}>
    <Container maxWidth={designTokens.spacing.containerMax} sx={{ py: 6 }}>
      <Grid container spacing={4}>
        <Grid item xs={6} sm={3}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, textTransform: "uppercase", letterSpacing: 1 }}>
            Services
          </Typography>
          {footerContent.services.map((link) => (
            <Typography key={link.label} variant="body2" sx={{ mb: 1, opacity: 0.79 }}>
              <Link component={RouterLink} to={link.path} sx={{ color: colors.white, textDecoration: "none", "&:hover": { opacity: 1 } }}>
                {link.label}
              </Link>
            </Typography>
          ))}
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, textTransform: "uppercase", letterSpacing: 1 }}>
            Company
          </Typography>
          {footerContent.company.map((link) => (
            <Typography key={link.label} variant="body2" sx={{ mb: 1, opacity: 0.79 }}>
              {link.path.includes("#") ? (
                <Link href={link.path} sx={{ color: colors.white, textDecoration: "none" }}>
                  {link.label}
                </Link>
              ) : (
                <Link component={RouterLink} to={link.path} sx={{ color: colors.white, textDecoration: "none" }}>
                  {link.label}
                </Link>
              )}
            </Typography>
          ))}
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, textTransform: "uppercase", letterSpacing: 1 }}>
            Solutions
          </Typography>
          {footerContent.solutions.map((link) => (
            <Typography key={link.label} variant="body2" sx={{ mb: 1, opacity: 0.79 }}>
              <Link component={RouterLink} to={link.path} sx={{ color: colors.white, textDecoration: "none" }}>
                {link.label}
              </Link>
            </Typography>
          ))}
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, textTransform: "uppercase", letterSpacing: 1 }}>
            Offices
          </Typography>
          {footerContent.offices.map((office) => (
            <Typography key={office} variant="body2" sx={{ mb: 1.5, opacity: 0.79, lineHeight: 1.6 }}>
              {office}
            </Typography>
          ))}
        </Grid>
      </Grid>
    </Container>

    <Divider sx={{ borderColor: "rgba(255,255,255,0.12)" }} />

    <Container maxWidth={designTokens.spacing.containerMax} sx={{ py: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box component="img" src={logo} alt={designTokens.company.name} sx={{ height: 40 }} />
        <Box display="flex" gap={1}>
          {[
            { icon: <FacebookIcon fontSize="small" />, href: "https://www.facebook.com" },
            { icon: <InstagramIcon fontSize="small" />, href: "https://www.instagram.com/sundeus_technology_social/profilecard/?igsh=MWxhbTQzbnAzM2N0YQ==" },
            { icon: <LinkedInIcon fontSize="small" />, href: "https://www.linkedin.com/company/sundeus-technologies-pvt-ltd/" },
          ].map((social, i) => (
            <IconButton
              key={i}
              component="a"
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: colors.white,
                border: "1px solid rgba(255,255,255,0.3)",
                width: 36,
                height: 36,
              }}
            >
              {social.icon}
            </IconButton>
          ))}
        </Box>
        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
          {designTokens.company.copyright}
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default Footer;
